import React from 'react';
import { Card } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { PLATFORM_ACCENTS } from '@/lib/format';
import { platformLogo } from '@/lib/logos';

/**
 * Recharge platform picker - choice of upstream service (olaparty, trumeet, ...).
 * Presentational; pure controlled component.
 */
export function RechargePlatformPicker({ platforms, value, onChange }) {
    return (
        <Card className="p-4 sm:p-5 mt-5">
            <Label className="text-xs uppercase tracking-wider text-muted-foreground">Platform</Label>
            <div className="mt-2 max-w-sm">
                <Select value={value} onValueChange={onChange}>
                    <SelectTrigger data-testid="recharge-platform-select">
                        <SelectValue placeholder="Select platform" />
                    </SelectTrigger>
                    <SelectContent>
                        {platforms.map((p) => (
                            <SelectItem key={p.key} value={p.key}>
                                <div className="flex items-center gap-2">
                                    {platformLogo(p.key) ? (
                                        <img src={platformLogo(p.key)} alt={p.name} className="h-5 w-5 rounded object-cover" />
                                    ) : (
                                        <span
                                            className="h-2.5 w-2.5 rounded-full"
                                            style={{ background: PLATFORM_ACCENTS[p.key]?.color }}
                                        />
                                    )}
                                    <span>
                                        {p.name}{' '}
                                        <span className="text-muted-foreground text-xs">({p.unit})</span>
                                    </span>
                                </div>
                            </SelectItem>
                        ))}
                    </SelectContent>
                </Select>
            </div>
        </Card>
    );
}

export default RechargePlatformPicker;
